<nav>
  <a routerLink="/linda">Linda</a>
  <a routerLink="/linda2">Linda v2</a>
  <a routerLink="/icons">Icons</a>
</nav>
